/*
 * @Description: computer actions
 */
import { ActionTree, ActionContext } from 'vuex'
import { RootState } from '@/store'
import { Mutations } from './mutations'
import { ComputerActionTypes } from './action-types'
import { ComputerMutationTypes } from './mutation-types'
import {
  ComputerState,
  ConfigState,
  NavListState,
  FooterConfigState,
  pageConfig,
  PageHeader,
  PageClassifyNav,
  PageCourseGroup,
  PageRichText
} from '@/constant/computerType'
type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<ComputerState, RootState>, 'commit'>

export interface Actions {
  [ComputerActionTypes.ACTION_SET_NAV_CONFIG](
    { commit }: AugmentedActionContext,
    navConfig: ConfigState
  ): void
  [ComputerActionTypes.ACTION_ADD_NAV_LIST](
    { commit }: AugmentedActionContext,
    navList: NavListState
  ): void
  [ComputerActionTypes.ACTION_DEL_NAV_LIST](
    { commit }: AugmentedActionContext,
    navList: NavListState
  ): void
  [ComputerActionTypes.ACTION_MODIFY_NAV_LIST](
    { commit }: AugmentedActionContext,
    navList: NavListState
  ): void

  [ComputerActionTypes.ACTION_SET_FOOTER_CONFIG](
    { commit }: AugmentedActionContext,
    footerConfig:FooterConfigState
  ): void
  [ComputerActionTypes.ACTION_PC_MODIFY_PAGE_CONFIG](
    { commit }: AugmentedActionContext,
    pageDesignConfig:Array<pageConfig | PageHeader | PageClassifyNav | PageCourseGroup | PageRichText>
  ): void
  [ComputerActionTypes.ACTION_SUBMIT_AND_PREVIEW_PAGE](
    { commit }: AugmentedActionContext,
    pageHeaderConfig:any
  ): void

}

export const actions: ActionTree<ComputerState, RootState> & Actions = {
  //导航
  [ComputerActionTypes.ACTION_SET_NAV_CONFIG](
  { commit }: AugmentedActionContext, navConfig: ConfigState) {
    commit(ComputerMutationTypes.SET_NAV_CONFIG, navConfig)
  },
  [ComputerActionTypes.ACTION_ADD_NAV_LIST](
    { commit }: AugmentedActionContext, navList: NavListState) {
    commit(ComputerMutationTypes.ADD_NAV_CONFIG_LIST, navList)
  },
  [ComputerActionTypes.ACTION_DEL_NAV_LIST](
    { commit }: AugmentedActionContext, navList: NavListState) {
    commit(ComputerMutationTypes.DEL_NAV_CONFIG_LIST, navList)

  },
  [ComputerActionTypes.ACTION_MODIFY_NAV_LIST](
    { commit }: AugmentedActionContext, navList: NavListState) {
    commit(ComputerMutationTypes.MODIFY_NAV_CONFIG_LIST, navList)
  },


  //页脚
  [ComputerActionTypes.ACTION_SET_FOOTER_CONFIG](
    { commit }: AugmentedActionContext, footerConfig: FooterConfigState) {
      commit(ComputerMutationTypes.SET_FOOTER_CONFIG, footerConfig)
  },


  //微门户页面配置
  [ComputerActionTypes.ACTION_PC_MODIFY_PAGE_CONFIG](
    { commit }: AugmentedActionContext, pageDesignConfig: Array<pageConfig | PageHeader | PageClassifyNav | PageCourseGroup | PageRichText>) {
    commit(ComputerMutationTypes.PC_MODIFY_PAGE_CONFIG, pageDesignConfig)
  },

  //预览保存
  [ComputerActionTypes.ACTION_SUBMIT_AND_PREVIEW_PAGE](
    { commit }: AugmentedActionContext, pageHeaderConfig:any) {
    commit(ComputerMutationTypes.SUBMIT_AND_PREVIEW_PAGE, pageHeaderConfig)
  },

}
